module.exports = __webpack_public_path__ + "img/shop3.00aa8142.png";